export const MAIN_NAV_BAR = () => import('../views/base/MainNavbar.vue');
export const MAIN_FOOTER = () => import('../views/base/MainFooter.vue');
export const INDEX = () => import('../views/Index.vue');
export const PRODUTOS = () => import('../views/Produtos.vue');
export const LAYOUT = () => import('../views/Layout.vue');
export const INSTITUCIONAL = () => import('../views/Institucional.vue');
export const BLOG = () => import('../views/Blog.vue');